import { Platform } from 'react-native'
import { colors } from '@/src/theme'
import { body2, headline1, label1, label2 } from '@/src/theme/typography'

export const NON_SCALING_TEXT_PROPS = {
  allowFontScaling: false,
  maxFontSizeMultiplier: 1,
} as const

export const SELECTABLE_CONTROL_HEIGHT = 40
export const CONTROL_BORDER_RADIUS = 8
export const STEP_ONE_CONTENT_TOP_MARGIN = 112
export const WAVE_ASPECT_RATIO = 138 / 390

export const getSelectableBorderColor = (isSelected: boolean) =>
  isSelected ? colors.primary : colors.grayMid

export const STEP_ONE_TITLE_STYLE = {
  ...headline1,
  color: '#050505',
  textAlign: 'center' as const,
}

export const STEP_ONE_DESCRIPTION_STYLE = {
  ...body2,
  color: '#353535',
  textAlign: 'center' as const,
}

export const SECTION_LABEL_STYLE = {
  ...label1,
  color: '#050505',
}

export const SELECTABLE_TEXT_STYLE = {
  ...label2,
  color: '#050505',
  ...(Platform.OS === 'ios' ? { paddingTop: 2 } : {}),
}
